const { Number } = require('../../Number/Number')
const { is } = require('../../is/is')

/**
 * Szám formázása.
 * @example formatNumber(1000) = 1 000
 * @example formatNumber(100000) = 1 000 000
 * @example formatNumber(10.3456) = 10.34
 * @param {unknown} x - Formázandó szám.
 * @returns {string} A formázott szám.
 */
module.exports.formatNumber = function formatNumber (x) {
  if (!is.number(x) && !is.string(x)) {
    return ''
  }

  const num = is.string(x) ? Number.parse(x) : x
  const tmp = is.float(num) ? num.toFixed(2) : num.toString()

  return tmp.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
